var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinEggSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "525px",
    height: "525px",
    viewBox: "0 0 525 525",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "protein_egg_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "protein_egg_selected",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FB6340",
    strokeWidth: 20,
    cx: 263,
    cy: 263,
    r: 240
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.756428,133.874952 C293.255834,116.176901 257.85428,118.306271 229.005841,139.961692 C209.858198,154.262513 189.591916,165.066578 171.66449,174.600247 C125.953936,198.941882 86.4904911,219.990886 104.419186,282.976878 C122.907201,347.891285 162.472225,397.185662 207.775828,411.639261 C216.81763,414.529093 225.907046,416 234.896789,416 C255.77064,416 276.2896,408.291414 295.335664,393.0771 C319.86763,373.501983 343.230802,365.741415 363.901496,358.896876 C398.033313,347.587569 425,338.611124 425,281.557446 C425,226.630602 381.831461,160.400792 328.753889,133.877171 L328.756428,133.874952 Z M264.5,354 C224.553487,354 192,321.497141 192,281.5 C192,241.553487 224.554753,209 264.5,209 C304.446513,209 337,241.554753 337,281.5 C337,321.495876 304.447146,354 264.5,354 Z",
    id: "Shape",
    fill: "#FB6340",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinEggSelected);
export default __webpack_public_path__ + "static/media/protein_egg_selected.ace4b2d958fa82129007b865331f069b.svg";
export { ForwardRef as ReactComponent };